import React from "react";

// Nocturne ground: one soft accent glow, half off-screen, behind all content.
export const LiquidBackground = () => (
  <>
    <div className="liquid-bg" aria-hidden="true">
      <div
        className="ambient-glow animate-drift"
        style={{ width: 460, height: 420, top: -180, left: -120, filter: "blur(10px)" }}
      />
      <div
        className="ambient-glow"
        style={{ width: 400, height: 400, bottom: -220, right: -160, opacity: 0.6 }}
      />
    </div>
    <div className="liquid-grain" aria-hidden="true" />
  </>
);
